import { ArrowUpRight } from "lucide-react";
import { JOURNAL } from "../data/products";
import { useLang } from "../i18n";
import { FadeIn, MaskLine, Micro } from "./Reveal";

export default function Journal() {
  const { t } = useLang();
  const posts = t("journal.posts");
  return (
    <section id="journal" data-testid="journal-section" className="scroll-mt-24 px-5 md:px-12 py-24 md:py-36 border-t border-white/5">
      <div className="flex flex-wrap items-end justify-between gap-6 mb-12 md:mb-16">
        <div>
          <FadeIn>
            <Micro className="text-gold/80">{t("journal.chapter")}</Micro>
          </FadeIn>
          <h2 className="font-display uppercase leading-[0.95] text-[clamp(2rem,5vw,4rem)] mt-5">
            <MaskLine delay={0.05}>{t("journal.h1a")}</MaskLine>
            <MaskLine delay={0.15} innerClass="text-outline">{t("journal.h1b")}</MaskLine>
          </h2>
        </div>
        <FadeIn delay={0.2}>
          <p className="text-sm md:text-base text-cream/50 max-w-xs">
            {t("journal.p")}
          </p>
        </FadeIn>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {JOURNAL.map((j, i) => (
          <FadeIn key={j.img} delay={i * 0.08}>
            <article
              data-testid={`journal-${i}`}
              data-cursor="view"
              className="group border border-white/10 bg-coal hover:border-gold/40 transition-colors duration-500"
            >
              <div className="overflow-hidden aspect-[16/10]">
                <img
                  src={j.img}
                  alt={posts[i]?.title || j.title}
                  loading="lazy"
                  className="w-full h-full object-cover opacity-75 grayscale-[30%] group-hover:grayscale-0 group-hover:scale-105 group-hover:opacity-95 transition duration-700"
                />
              </div>
              <div className="p-6 md:p-7">
                <div className="flex flex-wrap gap-3">
                  {(posts[i]?.tags || j.tags).map((tag) => (
                    <span key={tag} className="text-[9px] tracking-[0.25em] uppercase text-gold/80">
                      {tag}
                    </span>
                  ))}
                </div>
                <h3 className="font-display text-xl md:text-2xl leading-snug mt-4 group-hover:text-gold transition-colors duration-500">
                  {posts[i]?.title || j.title}
                </h3>
                <div className="mt-5 flex items-center gap-2 text-[10px] tracking-[0.25em] uppercase text-cream/40 group-hover:text-gold transition-colors duration-300">
                  {t("journal.read")} <ArrowUpRight className="w-3.5 h-3.5" />
                </div>
              </div>
            </article>
          </FadeIn>
        ))}
      </div>
    </section>
  );
}
